import React from 'react';
import { CTAButton } from './CTAButton';
const heroImg = 'https://cdn.magicpatterns.com/uploads/14FjjWju6YzfoToDwCawym/foto_1.jpg';
export function HeroSection() {
  const scrollToBuy = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('comprar');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-4 pb-0 px-[15px] relative block text-center" data-id="element-121">
      <div className="max-w-[500px] mx-auto px-[15px]" data-id="element-122">
        <div className="mb-[15px]" data-id="element-123">
          <h2 className="text-[26px] leading-[1.3] font-bold text-black m-0 mx-auto mb-[15px]" data-id="element-124">
            Recetas fáciles y saludables que te ayudarán a{' '}
            <strong data-id="element-125">perder peso rápidamente</strong> –{' '}
            <u className="green-underline" data-id="element-126">¡En menos de 20 minutos al día!</u>
          </h2>
        </div>

        <div className="my-5 mx-auto overflow-hidden rounded-xl shadow-[0_8px_20px_rgba(0,0,0,0.1)] max-w-[480px]" data-id="element-127">
          <img src={heroImg} alt="Recetario Digital - Recetas saludables y deliciosas" className="w-full h-auto block" data-id="element-128" />
        </div>

        <div className="max-w-[400px] mx-auto -mt-2.5 mb-5" data-id="element-129">
          <p className="text-dark-gray text-[14px] leading-[1.6] mb-[25px]" data-id="element-130">
            <strong className="text-primary-dark font-bold" data-id="element-131">
              Recibe acceso inmediato
            </strong>{' '}
            a más de 50 recetas diseñadas para ayudarte a{' '}
            <u className="green-underline" data-id="element-132">perder peso de manera saludable</u> y
            deliciosa.
          </p>
        </div>

        <CTAButton href="https://kleoyshop.com/cart/add?id=52708878745928&quantity=1" className="mt-0 mb-2 max-w-[400px] underline" data-id="element-133">
          ¡Comienza ahora!
        </CTAButton>
        <p className="text-[12px] text-gray italic text-center mb-[25px]" data-id="element-134">
          Obtén acceso instantáneo y empieza a bajar de peso hoy mismo.
        </p>

        {/* Beneficios clave */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[15px] mb-[30px]" data-id="element-135">
          {/* Beneficio 1 */}
          <div className="bg-white rounded-xl shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-5 text-center flex flex-col items-center" data-id="element-136">
            <div className="text-[28px] mb-2" data-id="element-137">⚡</div>
            <h3 className="text-[16px] font-bold text-black mb-1.5" data-id="element-138">
              Fácil y rápido
            </h3>
            <p className="text-[14px] text-dark-gray leading-[1.4] m-0" data-id="element-139">
              Recetas simples que puedes preparar en{' '}
              <strong data-id="element-140">menos de 30 minutos</strong>.
            </p>
          </div>

          {/* Beneficio 2 */}
          <div className="bg-white rounded-xl shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-5 text-center flex flex-col items-center" data-id="element-141">
            <div className="text-[28px] mb-2" data-id="element-142">⚖️</div>
            <h3 className="text-[16px] font-bold text-black mb-1.5" data-id="element-143">
              Pérdida de peso efectiva
            </h3>
            <p className="text-[14px] text-dark-gray leading-[1.4] m-0" data-id="element-144">
              Baja peso de manera <strong data-id="element-145">saludable sin pasar hambre</strong>.
            </p>
          </div>

          {/* Beneficio 3 */}
          <div className="bg-white rounded-xl shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-5 text-center flex flex-col items-center" data-id="element-146">
            <div className="text-[28px] mb-2" data-id="element-147">📱</div>
            <h3 className="text-[16px] font-bold text-black mb-1.5" data-id="element-148">
              Accesibilidad
            </h3>
            <p className="text-[14px] text-dark-gray leading-[1.4] m-0" data-id="element-149">
              Accede a las recetas en tu <strong data-id="element-150">móvil o computadora</strong>,
              ¡cuando quieras!
            </p>
          </div>

          {/* Beneficio 4 */}
          <div className="bg-white rounded-xl shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-5 text-center flex flex-col items-center" data-id="element-151">
            <div className="text-[28px] mb-2" data-id="element-152">🍽️</div>
            <h3 className="text-[16px] font-bold text-black mb-1.5" data-id="element-153">
              Sabores variados
            </h3>
            <p className="text-[14px] text-dark-gray leading-[1.4] m-0" data-id="element-154">
              Disfruta de platos <strong data-id="element-155">saludables y sabrosos</strong>, ¡sin
              complicaciones!
            </p>
          </div>
        </div>
      </div>
    </section>;
}